import React from 'react';
import { FaPhone, FaTwitter, FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

const Footer1 = () => {
  const styles = {
    footerWrapper: {
      backgroundColor: '#f9f9f9',
      padding: '40px 60px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      color: '#333',
    },
    columns: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      marginBottom: '30px',
    },
    column: {
      flex: '1',
      minWidth: '180px',
      marginBottom: '20px',
    },
    heading: {
      fontWeight: 'bold',
      marginBottom: '10px',
      borderBottom: '1px solid #ccc',
      paddingBottom: '5px',
    },
    link: {
      display: 'block',
      color: '#333',
      textDecoration: 'none',
      marginBottom: '8px',
    },
    contact: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '10px',
    },
    socialIcons: {
      display: 'flex',
      gap: '10px',
      marginBottom: '15px',
    },
    icon: {
      backgroundColor: '#fff',
      borderRadius: '50%',
      padding: '8px',
      border: '1px solid #ccc',
      color: '#333',
      fontSize: '14px',
      cursor: 'pointer',
    },
    inputGroup: {
      display: 'flex',
      marginTop: '10px',
    },
    input: {
      flex: 1,
      padding: '8px',
      border: '1px solid #ccc',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
    button: {
      padding: '8px 15px',
      backgroundColor: '#d71920',
      color: '#fff',
      border: 'none',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
      cursor: 'pointer',
    },
    copyright: {
      backgroundColor: '#d71920',
      color: '#fff',
      textAlign: 'center',
      padding: '10px',
      fontWeight: 'bold',
    },
  };

  return (
    <div>
      <div style={styles.footerWrapper}>
        <div style={styles.columns}>
          <div style={styles.column}>
            <div style={styles.heading}>COMPANY</div>
            <a href="#" style={styles.link}>Terms & conditions</a>
            <a href="#" style={styles.link}>Payment Security</a>
            <a href="#" style={styles.link}>Refunds Policy</a>
          </div>
          <div style={styles.column}>
            <div style={styles.heading}>POLICIES</div>
            <a href="#" style={styles.link}>Privacy Policy</a>
            <a href="#" style={styles.link}>Disclaimer</a>
            <a href="#" style={styles.link}>About Us</a>
          </div>
          <div style={styles.column}>
            <div style={styles.heading}>RESOURCES</div>
            <a href="#" style={styles.link}>Careers</a>
          </div>
          <div style={styles.column}>
            <div style={styles.heading}>GET IN TOUCH</div>
            <a href="#" style={styles.link}>Contact Us</a>
          </div>
          <div style={styles.column}>
            <div style={styles.heading}>NEED MY TRAVEL HELP?</div>
            <div style={styles.contact}>
              <FaPhone />
              <span>Got Questions? Call us 24/7!</span>
            </div>
            <a href="tel:918130405884" style={{ ...styles.link, color: '#d71920', fontWeight: 'bold' }}>
              Call Us: 917303455505
            </a>
            <div style={styles.socialIcons}>
             <a href="https://x.com/Pearltt55?t=_Xpt7ZAEt-I9RNlnD1o5WQ&s=09" target="_blank" rel="noopener noreferrer">
  <FaTwitter />
</a>
<a href="https://www.facebook.com/pearltoursandtravelsangli/" target="_blank" rel="noopener noreferrer">
  <FaFacebookF />
</a>
<a href="https://www.instagram.com/pearl_tours_travels_sangli/" target="_blank" rel="noopener noreferrer">
  <FaInstagram />
</a>
{/* <a href="https://linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer">
  <FaLinkedinIn />
</a> */}
<a href="http://www.youtube.com/@pearltourstravelssangli4768" target="_blank" rel="noopener noreferrer">
  <FaYoutube />
</a>

            </div>
           
          </div>
        </div>
      </div>
      <div style={styles.copyright}>
        © Copyright <strong>PEARL TOURS & TRAVELS</strong> All Rights Reserved
      </div>
    </div>
  );
};

export default Footer1;
